import { FC } from 'react';

import { VSpacing, VSpacingContainer } from '@hh.ru/magritte-ui';

import { AllFiltersModalFilter } from 'components/CampaignsDashboard/components/CampaignsFiltersPanel/components/AllFiltersModal/AllFiltersModalFilter';
import {
    getTabFilterList,
    needToShowFilter,
} from 'components/CampaignsDashboard/components/CampaignsFiltersPanel/utils';

import { CampaignFilter, setCampaignsFiltersDraft } from 'store/models/campaignsFilters';
import { useDispatch, useSelector } from 'store/utils';

export const AllFiltersModalContent: FC = () => {
    const campaignFilters = useSelector((state) => state.campaignsFilters.campaignsFilters);
    const campaignsFiltersDraft = useSelector((state) => state.campaignsFilters.campaignsFiltersDraft);
    const campaignsCurrentTab = useSelector((state) => state.campaignsDashboard.campaignsCurrentTab);
    const dispatch = useDispatch();

    const toggleFilterHandler = (campaignFilter: CampaignFilter, id: string, checked: boolean) => {
        const newFilter = new Set(campaignsFiltersDraft[campaignFilter]);
        if (checked) {
            newFilter.add(id);
        } else {
            newFilter.delete(id);
        }

        dispatch(
            setCampaignsFiltersDraft({
                ...campaignsFiltersDraft,
                [campaignFilter]: newFilter,
            })
        );
    };

    return (
        <>
            <VSpacingContainer default={32}>
                {Object.entries(campaignFilters).map(([filterName, filterList]) => {
                    const tabFilterList = getTabFilterList(
                        filterName,
                        filterList as Record<string, string>,
                        campaignsCurrentTab
                    );

                    return (
                        needToShowFilter(filterName, tabFilterList) && (
                            <AllFiltersModalFilter
                                key={filterName}
                                filterName={filterName as CampaignFilter}
                                filterList={tabFilterList}
                                checkedFilters={campaignsFiltersDraft[filterName as CampaignFilter]}
                                onToggleFilter={toggleFilterHandler}
                            />
                        )
                    );
                })}
            </VSpacingContainer>
            <VSpacing default={16} />
        </>
    );
};
